const pluralizationRules = {

}

export default pluralizationRules
